import axios from 'axios'
import { useEffect, useState } from 'react'
import { baseUrl } from '../../baseUrl'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { MagnifyingGlass } from 'react-loader-spinner'

const Blogs = () => {
    const [blogs, setBlogs] = useState([])
    const [loading, setLoading] = useState(false)

    const getTextPreview = (html, wordLimit = 40) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const text = div.textContent || div.innerText || "";
        const words = text.trim().split(/\s+/);
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(" ") + "..."
            : text;
    };


    const getBlogs = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${baseUrl}/blog/web-blogs`);
            setBlogs(res.data.blogs || []);
        } catch (err) {
            console.error("Error fetching blogs:", err);
            // Optionally, show error message to user here
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getBlogs()
    }, [])
    return (
        <div className='container mt-1 mt-lg-3 mb-2'>
            <h2>Blogs</h2>
            <div className='row mt-2'>
                {
                    loading &&
                    <MagnifyingGlass
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="magnifying-glass-loading"
                        wrapperStyle={{}}
                        wrapperClass="magnifying-glass-wrapper"
                        glassColor="#c0efff"
                        color="#8000df"
                    />
                }
                {
                    !loading && blogs.length < 1 &&
                    <h4>Coming Soon...</h4>
                }
                {
                    !loading && blogs.length > 0 &&
                    blogs.map((blog, i) =>
                        <div className='col-lg-4'>
                            <article className="blog-post-item">
                                <div className="post-thumb">
                                    <img src={`${process.env.REACT_APP_API_URL}${blog.imageUrl}`} alt="" className="img-fluid" />
                                </div>
                                <div className="post-item mt-4">
                                    <div className="post-meta">
                                        <span className="post-date"><i className="fa fa-calendar-alt mr-2"></i>{moment(blog.createdAt).format('DD MMM YYYY')}</span>
                                        <span className="post-author"><i className="fa fa-user mr-2"></i>Monarch Institute</span>
                                    </div>
                                    <h3 className="post-title"><Link to={`/blog/${blog._id}`}>{blog.title}</Link></h3>
                                    <div className="post-content">
                                        <p>{getTextPreview(blog.detail, 40)}</p>
                                        <Link to={`/blog/${blog._id}`} className="read-more">Read More <i className="fa fa-angle-right ml-2"></i></Link>
                                    </div>
                                </div>
                            </article>
                        </div>
                    )
                }


            </div>
        </div>
    )
}

export default Blogs
